import React from "react";
import "./custom_checkbox.scss";
// a wrapper class for a regular HTML checkbox
function CheckboxWrapper(props) {
  return (
    <label className="check-container" style={{ paddingLeft: "20px" }}>
      <input
        type="checkbox"
        style={{ marginRight: "5px" }} 
        {...props}
        className="checkbox"
      />
      <span className="checkmark"
          style={{
            backgroundColor: props.disabled ? "#F0F0F0" : "",
            cursor: props.disabled ? "not-allowed" : "",
          }}
      ></span>
    </label>
  );
}

export default CheckboxWrapper;
